import styled from '@emotion/styled';
import { FormControlLabel } from '@mui/material';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Divider = styled.div`
  width: 1px;
  height: 12px;
  background-color: var(--dk-bg-strong, #e7e9ec);
  margin: 0 12px;
`;

/**
 * FormControlLabel 이 <label> 안에 input 을 품으므로 htmlFor(=id) 없이 라벨 클릭 토글이 동작한다.
 * 기본 margin(-11px/16px)은 제거하고, 체크박스-라벨 간격은 기존과 같은 8px 로 맞춘다.
 */
const CheckLabel = styled(FormControlLabel)`
  margin: 0;
  gap: 8px;

  .MuiFormControlLabel-label {
    font-size: 16px;
    font-weight: 400;
  }
`;

export { Wrapper, Divider, CheckLabel };
